import { render } from "./prohubTabs.vue?vue&type=template&id=0212c3bc&scoped=true"
import script from "./prohubTabs.vue?vue&type=script&lang=js"
export * from "./prohubTabs.vue?vue&type=script&lang=js"

import "./prohubTabs.vue?vue&type=style&index=0&id=0212c3bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0212c3bc"]])

export default __exports__